<template>
  <v-form ref="form">
    <v-card>
      <v-card-title class="headline">{{
        $t("user.assign_coach_pef")
      }}</v-card-title>
      <v-card-text>
        <UserPicker
          required
          role="COACH"
          :readonly="edit"
          v-model="formModel.coach"
          :label="$t('user.select-coach')"
        />

        <UserPicker
          required
          :readonly="edit"
          role="PEF"
          v-model="formModel.pef"
          :label="$t('user.select-pef')"
        />
        <DatePicker
          v-model="formModel.start_period"
          :label="$tc('user.start_date', 1)"
        />
        {{ edit }}

        <DatePicker
          v-model="formModel.end_period"
          :label="$tc('user.end_date', 1)"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="$emit('close')">
          {{ $t("common.cancel") }}
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="_submit()"
          :loading="isLoading"
        >
          {{ $t("common.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { ADD, DELETE, FETCH } from "@/store/action-types"
import { mapActions } from "vuex"
import UserPicker from "@/components/form/UserPicker.vue"
import DatePicker from "@/components/form/DatePicker.vue"
import FormMixin from "@/mixins/FormMixin.vue"

export default {
  name: "PrcForm",
  components: { DatePicker, UserPicker },
  mixins: [FormMixin],
  props: {
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Object,
      required: false,
      default: () => ({
        start_period: "",
        end_period: "",
        coach: "",
        pef: "",
      }),
    },
  },
  mounted() {
    this.formModel.coach = this.value?.coach
    this.formModel.pef = this.value?.pef
  },
  data() {
    return {
      dialogListPef: false,
      isLoading: false,
      formModel: {
        end_period: this.value.end_period,
        start_period: this.value.start_period,
        coach: this.value.coach,
        pef: this.value.pef,
      },
    }
  },
  computed: {
    current_user() {
      return this.$store.state.user.profile
    },
  },
  watch: {
    value() {
      this.formModel = this.value
    },
  },
  methods: {
    ...mapActions("user_pcr", [FETCH, DELETE, ADD]),

    deleteAction(item) {
      if (confirm(this.$t("common.delete_confirm"))) {
        this.DELETE({ pef_id: item.pef.id, coach_id: item.coach.id }).then(
          () => {
            this.$emit("deleted")
          }
        )
      }
    },

    async _submit() {
      this.isLoading = true
      this.formModel.edit = this.edit
      await this.submit(
        ["start_period", "end_period", "coach", "pef", "edit"],
        null,
        null,
        async () => {
          this.formModel.start_period = ""
          this.formModel.end_period = ""
          this.$emit("add")
          this.$emit("close")
        }
      )
      this.isLoading = false
    },
  },
}
</script>
